import { Card, Grid, Typography } from "@material-ui/core";
import { blueGrey } from "@material-ui/core/colors";
import React from "react";

const RequiredFieldsCard = () => {
  return (
    <>
      {REQUIRED_FIELDS.map((f, i) => (
        <Grid item xs={6} md={2} key={i}>
          <Card
            variant="outlined"
            style={{
              padding: 16,
              backgroundColor: blueGrey[50],
            }}
          >
            <Grid
              container
              alignItems="center"
              alignContent="center"
              justify="center"
              style={{ height: "100%", minHeight: 76 }}
            >
              <Typography variant="h6" style={{ textAlign: "center" }}>
                {f}
              </Typography>
            </Grid>
          </Card>
        </Grid>
      ))}
    </>
  );
};

export default RequiredFieldsCard;

const REQUIRED_FIELDS = [
  "Email",
  "Contraseña",
  "Nombre",
  "Primer apellido",
  "Segundo apellido",
  "DNI",
  "Teléfono",
  "Idioma de contacto",
  "Fecha de nacimiento",
  "Política de privacidad",
  "Aceptar comunicaciones",
  "Autorización",
];
